import type { CustomTheme } from '../../types';

const lightTheme: CustomTheme = {
  '--pcm-overlay-background': 'rgba(71, 88, 107, 0.24)',
  '--pcm-modal-box-shadow': '0px 2px 4px rgba(0, 0, 0, 0.1)',
  '--pcm-body-background': '#ffffff',
  '--pcm-body-background-secondary': '#EFF0F2',
  '--pcm-body-background-tertiary': '#F9F9FA',

  '--pcm-body-color': '#181B1E',
  '--pcm-body-color-secondary': '#8B8EA1',
  '--pcm-body-color-tertiary': '#DCDFE6',

  '--pcm-body-action-color': '#999999',
  '--pcm-button-border-color': '#EAECF0',
  '--pcm-accent-color': '#A257FA',

  // button
  '--pcm-button-font-weight': '500',
  '--pcm-button-hover-shadow': '0px 2px 4px rgba(0, 0, 0, 0.05)',

  // primary button
  '--pcm-primary-button-color': '#ffffff',
  '--pcm-primary-button-bankground': '#181B1E',
  '--pcm-primary-button-hover-background': '#353738',

  // secondary button
  '--pcm-secondary-button-color': '#181B1E',
  '--pcm-secondary-button-bankground': '#EFF0F2',
  '--pcm-secondary-button-hover-background': '#D9DBDD',
};

export default lightTheme;
